import {initElements} from "../define/shared";

export default function initHeader() {
    initElements(".siteHeader", header => {

    });
}
